import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "content" }
const _hoisted_2 = { class: "pause-overlay-container" }
const _hoisted_3 = { class: "crossword-content-wrap" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "crossword-puzzle row" }
const _hoisted_6 = { class: "col-12 col-lg-6" }
const _hoisted_7 = {
  key: 0,
  class: "selected-clue-header"
}
const _hoisted_8 = { style: {"display":"contents","font-weight":"bold"} }
const _hoisted_9 = {
  key: 0,
  style: {"display":"contents"}
}
const _hoisted_10 = {
  key: 1,
  class: "selected-clue-header"
}
const _hoisted_11 = { style: {"display":"contents","font-weight":"bold"} }
const _hoisted_12 = { style: {"display":"contents"} }
const _hoisted_13 = {
  class: "crossword-grid mx-auto",
  id: "crossword-table"
}
const _hoisted_14 = { ref: "crosswordTable" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "special-cell-circle-overlay"
}
const _hoisted_17 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_18 = { class: "clue-number" }
const _hoisted_19 = {
  key: 1,
  class: "create-match-number-across"
}
const _hoisted_20 = {
  key: 0,
  class: "creator-good-clue"
}
const _hoisted_21 = {
  key: 1,
  class: "creator-good-clue"
}
const _hoisted_22 = {
  key: 2,
  class: "creator-unknown-clue"
}
const _hoisted_23 = {
  key: 2,
  class: "create-match-number-down"
}
const _hoisted_24 = {
  key: 0,
  class: "creator-good-clue"
}
const _hoisted_25 = {
  key: 1,
  class: "creator-good-clue"
}
const _hoisted_26 = {
  key: 2,
  class: "creator-unknown-clue"
}
const _hoisted_27 = { class: "lh-sm small mt-2 op-06" }
const _hoisted_28 = ["colspan"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "col-12 col-lg-6" }
const _hoisted_31 = { class: "crossword-clues" }
const _hoisted_32 = { class: "crossword-clues-section" }
const _hoisted_33 = {
  class: "crossword-clue-list",
  id: "crossword-clue-list-across"
}
const _hoisted_34 = ["onClick", "id"]
const _hoisted_35 = { style: {"user-select":"none"} }
const _hoisted_36 = { class: "crossword-clues-section" }
const _hoisted_37 = {
  class: "crossword-clue-list",
  id: "crossword-clue-list-down"
}
const _hoisted_38 = ["onClick", "id"]
const _hoisted_39 = { style: {"user-select":"none"} }
const _hoisted_40 = {
  key: 0,
  class: "pause-overlay",
  style: {"pointer-events":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CrosswordKeyboard = _resolveComponent("CrosswordKeyboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowMobileKeyboard && !_ctx.isPuzzleLocked && !_ctx.isReadOnly)
      ? (_openBlock(), _createBlock(_component_CrosswordKeyboard, {
          key: 0,
          clue: _ctx.selectedClue,
          xSelect: _ctx.xSelect
        }, null, 8, ["clue", "xSelect"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.isCreatorMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.selectedClue?.number) + " " + _toDisplayString(_ctx.xSelect ? "ACROSS" : "DOWN") + ". ", 1),
                        _cache[5] || (_cache[5] = _createTextVNode("   ")),
                        (_ctx.crossword && _ctx.selectedClue)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_ctx.xSelect)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    class: "clue-input",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.crossword.acrossClues.find(clue => clue?.id === _ctx.selectedClue?.id).clue) = $event)),
                                    placeholder: "Enter clue",
                                    onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 544)), [
                                    [_vModelText, _ctx.crossword.acrossClues.find(clue => clue?.id === _ctx.selectedClue?.id).clue]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    class: "clue-input",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.crossword.downClues.find(clue => clue?.id === _ctx.selectedClue?.id).clue) = $event)),
                                    placeholder: "Enter clue",
                                    onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 544)), [
                                    [_vModelText, _ctx.crossword.downClues.find(clue => clue?.id === _ctx.selectedClue?.id).clue]
                                  ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectedClue?.number) + " " + _toDisplayString(_ctx.xSelect ? "ACROSS" : "DOWN") + ". ", 1),
                        _cache[6] || (_cache[6] = _createTextVNode("   ")),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.selectedClue?.clue), 1)
                      ])),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.y, (y) => {
                          return (_openBlock(), _createElementBlock("tr", { key: y }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.x, (x) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: x,
                                class: "crossword-grid-cell",
                                onClick: ($event: any) => (_ctx.clickCell(x - 1, y - 1)),
                                style: _normalizeStyle(_ctx.cellStyle)
                              }, [
                                (_ctx.isSpecialCellCircle(x, y))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("input", {
                                  id: _ctx.getCellId(x - 1, y - 1),
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.grid[x - 1][y - 1]) = $event),
                                  class: _normalizeClass({
                                         'black-cell': _ctx.isBlackCell(x - 1, y - 1),
                                         'highlighted-cell': !_ctx.isReadOnly && _ctx.shouldHighlightCell(x - 1, y - 1),
                                         'selected-cell': !_ctx.isReadOnly && _ctx.isSelectedCell(x - 1, y - 1),
                                         'marked-red-cell': _ctx.isMarkedRedCell(_ctx.getCellId(x - 1, y - 1)),
                                         'special-cell-highlight': _ctx.isSpecialCellHighlight(x, y),
                                         'creator-mode-cell': _ctx.isCreatorMode
                                         }),
                                  disabled: _ctx.isPuzzleLocked || _ctx.isReadOnly,
                                  onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
                                  type: "text",
                                  inputmode: "none",
                                  autocomplete: "off",
                                  readonly: ""
                                }, null, 42, _hoisted_17), [
                                  [_vModelText, _ctx.grid[x - 1][y - 1]]
                                ]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getCellNumber(x - 1, y - 1)), 1),
                                (_ctx.getCreatorDisplayCell(x - 1, y - 1, 'ACROSS'))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS')) > 0 && !_ctx.isClueComplete(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS'), 'ACROSS'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS'))) + "▷ ", 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS')) === 1 && _ctx.isClueComplete(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS'), 'ACROSS'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " ✓ ▷ "))
                                        : _createCommentVNode("", true),
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'ACROSS')) === 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ? ▷ "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.getCreatorDisplayCell(x - 1, y - 1, 'DOWN'))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN')) > 0 && !_ctx.isClueComplete(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN'), 'DOWN'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN'))) + "▽ ", 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN')) === 1 && _ctx.isClueComplete(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN'), 'DOWN'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, " ✓ ▽ "))
                                        : _createCommentVNode("", true),
                                      (_ctx.clueToNumber.get(_ctx.getClueForCoords(x - 1, y - 1, 'DOWN')) === 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ? ▽ "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 12, _hoisted_15))
                            }), 128))
                          ]))
                        }), 128)),
                        _createElementVNode("tr", _hoisted_27, [
                          _createElementVNode("td", {
                            colspan: _ctx.crossword.x,
                            style: {"padding-top":"5px","border":"none"}
                          }, [
                            (_ctx.isMobileKeyboardEligible() && !_ctx.isShowMobileKeyboard && !_ctx.isPuzzleLocked && !_ctx.isReadOnly)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Puzzle out of focus. Click cell to resume. "))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_28)
                        ])
                      ])
                    ], 512)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "p-0 m-0 mb-1" }, "ACROSS", -1)),
                      _createElementVNode("ul", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.acrossClues, (clue) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["crossword-clue", { 'highlighted-clue': _ctx.shouldHighlightClue(clue.id) }]),
                            onClick: ($event: any) => (!_ctx.isPuzzleLocked && _ctx.selectClue(clue, true)),
                            key: clue.number,
                            id: _ctx.getClueId(clue.x, clue.y, true)
                          }, [
                            _createElementVNode("strong", _hoisted_35, _toDisplayString(clue.number) + ". ", 1),
                            _createElementVNode("span", {
                              style: _normalizeStyle({ userSelect: _ctx.isPuzzleLocked ? 'none' : 'text' })
                            }, _toDisplayString(clue.clue), 5)
                          ], 10, _hoisted_34))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "p-0 m-0 mb-1" }, "DOWN", -1)),
                      _createElementVNode("ul", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.downClues, (clue) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["crossword-clue", { 'highlighted-clue': _ctx.shouldHighlightClue(clue.id) }]),
                            onClick: ($event: any) => (!_ctx.isPuzzleLocked && _ctx.selectClue(clue, false)),
                            key: clue.number,
                            id: _ctx.getClueId(clue.x, clue.y, false)
                          }, [
                            _createElementVNode("strong", _hoisted_39, _toDisplayString(clue.number) + ". ", 1),
                            _createElementVNode("span", {
                              style: _normalizeStyle({ userSelect: _ctx.isPuzzleLocked ? 'none' : 'text' })
                            }, _toDisplayString(clue.clue), 5)
                          ], 10, _hoisted_38))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.isPuzzleLocked)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[9] || (_cache[9] = [
              _createElementVNode("span", { style: {"position":"absolute","top":"100px"} }, " Click play to resume. ", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"modal fade\" id=\"autoFillNotificationModal\" tabindex=\"-1\" aria-labelledby=\"autoFillNotificationModalLabel\" aria-hidden=\"true\" data-v-5e158254><div class=\"modal-dialog modal-dialog-centered\" data-v-5e158254><div class=\"modal-content\" data-v-5e158254><div class=\"modal-header\" data-v-5e158254><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-5e158254></button></div><div class=\"modal-body\" data-v-5e158254><div class=\"row p-4 bg-white d-flex align-items-center justify-content-center rounded\" data-v-5e158254><div class=\"col-12 p-4\" data-v-5e158254><h3 class=\"mb-2\" data-v-5e158254>Unable to Autofill Puzzle</h3><p class=\"mb-4 fw-normal text-smaller text-black-50\" data-v-5e158254> Unable to autofill the puzzle — no viable solutions found using words from our list. </p><button type=\"button\" class=\"button button-large m-0 bg-color text-light h-op-08\" data-bs-dismiss=\"modal\" data-v-5e158254>Dismiss</button></div></div></div></div></div></div>", 1))
    ])
  ], 64))
}